import type { ReactNode } from 'react';

export function Loading({ text = '正在加载…' }: { text?: string }) {
  return <div className="panel empty-state"><span className="spinner" />{text}</div>;
}

export function ErrorPanel({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return <div className="panel error-panel"><strong>加载失败</strong><p>{message}</p>{onRetry && <button type="button" onClick={onRetry}>重试</button>}</div>;
}

export function Empty({ text = '暂无数据' }: { text?: string }) {
  return <div className="empty-state">{text}</div>;
}

export function PageHeader({ title, description, actions }: { title: string; description?: string; actions?: ReactNode }) {
  return <header className="page-header"><div><h1>{title}</h1>{description && <p>{description}</p>}</div><div className="page-actions">{actions}</div></header>;
}

export function StatusBadge({ status }: { status: unknown }) {
  const value = String(status || 'unknown');
  const labels: Record<string, string> = {
    active: '有效', pending: '待审批', disabled: '已停用', expired: '已过期', revoked: '已撤销', missing: '未授权', exhausted: '已耗尽'
  };
  return <span className={`badge badge-${value}`}>{labels[value] || value}</span>;
}

export function StatCard({ label, value, detail }: { label: string; value: ReactNode; detail?: ReactNode }) {
  return <div className="stat-card"><span>{label}</span><strong>{value}</strong>{detail && <small>{detail}</small>}</div>;
}

export function Modal({ title, children, onClose }: { title: string; children: ReactNode; onClose: () => void }) {
  return <div className="modal-backdrop" role="presentation" onMouseDown={onClose}>
    <section className="modal" role="dialog" aria-modal="true" aria-label={title} onMouseDown={(event) => event.stopPropagation()}>
      <div className="modal-header"><h2>{title}</h2><button className="ghost icon-button" type="button" onClick={onClose}>×</button></div>
      {children}
    </section>
  </div>;
}

export function ConfirmButton({ children, message, onConfirm, danger = false, disabled = false }: {
  children: ReactNode; message: string; onConfirm: () => void | Promise<void>; danger?: boolean; disabled?: boolean;
}) {
  return <button type="button" className={danger ? 'danger' : ''} disabled={disabled} onClick={() => { if (window.confirm(message)) void onConfirm(); }}>{children}</button>;
}
